<script>
  import {fly} from 'svelte/transition'
  import Btn from "./Btn.svelte";
</script>


<article in:fly={{ y: 20 }}>
  <h2>Get your dog featured!</h2>
  <p>It's quick and easy!</p>
  <div class="steps">
    <div class="step">
      <h3>Step 1: Sign in</h3>
      <p>Hit Get Started and choose your login provider, no account needed!</p>
    </div>
  
    <div class="step">
      <h3>Step 2: Submit a new post</h3>
      <p>Upload a pic or vid (or multiple), give us a caption and your IG handle.</p>
    </div>
  
    <div class="step">
      <h3>Step 3: Check back for updates</h3>
      <p>Log back in to check the status or keep an eye on our IG to see your pup in the limelight (we won't email you😇)</p>
    </div>
  </div>
  <div class="cta">
    <Btn on:click>get started</Btn>
  </div>

  <div class="disclaimer">
    <p>By submitting images or video to Healthybud you provide us with consent to utilize your provided content in Instagram posts and other related marketing efforts for Healthybud Co. </p>
  </div>
</article>

<style>
	article {
    text-align: left
  }
  .steps {
    display: flex;
    flex-direction :column;
    gap: .5rem;
    margin-bottom: 1rem;
  }
  .step {
    border-radius: 1rem;
    background: #fff;
    padding: 1rem;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  }
  .step h3 {
    margin-top: 0;
    margin-bottom: .25rem
  }
  .step p {
    margin: 0;
  }
  .disclaimer {
    font-size: .875rem
  }
</style>